import { useTranslation } from 'react-i18next';

/**
 * Pagination — 簡易頁碼器
 *
 * props: { page, totalPages, onChange(newPage), total }
 */
export function Pagination({ page, totalPages, total, onChange }) {
    const { t } = useTranslation('survey');
    if (!totalPages || totalPages <= 1) {
        return (
            <div className="mt-4 mono-caption text-ink-400 text-right">
                {t('pagination.totalCount', { total: total ?? 0 })}
            </div>
        );
    }

    // 顯示前後 1~2 頁 + 省略號
    const pages = [];
    const add = (p) => { if (!pages.includes(p) && p >= 1 && p <= totalPages) pages.push(p); };
    add(1);
    for (let p = page - 1; p <= page + 1; p++) add(p);
    add(totalPages);
    pages.sort((a, b) => a - b);

    return (
        <div className="mt-4 flex items-center justify-end gap-1.5 mono-caption">
            <span className="mr-2 text-ink-400">{t('pagination.totalCount', { total: total ?? 0 })}</span>
            <PageButton disabled={page <= 1} onClick={() => onChange(page - 1)}>‹</PageButton>
            {pages.map((p, i) => (
                <span key={p} className="flex items-center gap-1.5">
                    {i > 0 && p - pages[i - 1] > 1 && <span className="px-1 text-ink-300">…</span>}
                    <PageButton active={p === page} onClick={() => onChange(p)}>{p}</PageButton>
                </span>
            ))}
            <PageButton disabled={page >= totalPages} onClick={() => onChange(page + 1)}>›</PageButton>
        </div>
    );
}

function PageButton({ children, active, disabled, onClick }) {
    const base = 'inline-flex items-center justify-center min-w-[28px] h-7 px-2 text-xs rounded-md transition tnum';
    if (active) return <span className={`${base} bg-accent-500 text-white font-medium`}>{children}</span>;
    if (disabled) return <span className={`${base} bg-cream-100 text-ink-300 cursor-not-allowed`}>{children}</span>;
    return <button onClick={onClick} className={`${base} bg-white border border-cream-200 text-ink-700 hover:bg-cream-50`}>{children}</button>;
}
